import React, { useMemo, useState } from 'react';
import GallMap from './GallMap';
import useMapData from './useMapData';

const MapWrapper = () => {
  const { loading, error, data } = useMapData();

	const [filter, setFilter] = useState('all'); // filter state

  const locationData = useMemo(() => {
    if (!data || !data.namespace) {return [];}

    const dataObj = [data.namespace];
    return dataObj.flatMap((namespace) => {
      const { entities } = namespace;
      return entities.nodes.flatMap((entity) => {
        const { name } = entity;
				const incident = entity.events.find((event) => event.check.status !== 0);
        const output = entity.events.find((event) => event.check.name === "location")?.check?.output;
        if (!output) {
          return [];
        }

        const parts = output.replace("Computer Location: ", "").split(", ");
        const object = {};

        parts.forEach(part => {
          const [key, value] = part.split(": ");
          const cleanKey = key.trim();
          const cleanValue = value ? value.trim() : null;
          object[cleanKey] = cleanValue;
        });

        if (!object.Latitude || !object.Longitude) {
          return [];
        }

        return {
          type: "Feature",
          properties: { cluster: false, name, incident, namespace: data.namespace.name, ...object },
          geometry: { type: "Point", coordinates: [parseFloat(object.Longitude), parseFloat(object.Latitude)] }
        };
      });
    });
  }, [data]);

  if (loading) {return <p>Loading...</p>;}
  if (error) {return <p>Error</p>;}

	const points = locationData.filter((point) => {
		if (filter === 'incidents') {
			return point.properties.incident;
		}
		return true;
	});

  return (
    <div>
			<button
				onClick={() => setFilter('incidents')}
				style={{
					backgroundColor: filter === 'incidents' ? '#34B0CF' : '#3E4C55',
					border: 'none',
					borderRadius: '5px',
					padding: '10px',
					margin: '0 5px',
					cursor: 'pointer',
          color: '#FFFFFF',
          fontFamily: 'Arial'
				}}
			>
				Incidents
			</button>
			<button
				onClick={() => setFilter('all')}
				style={{
					backgroundColor: filter === 'all' ? '#34B0CF' : '#3E4C55',
					border: 'none',
					borderRadius: '5px',
					padding: '10px',
					margin: '0 5px',
					cursor: 'pointer',
          color: '#FFFFFF',
          fontFamily: 'Arial'
				}}
			>
				All Terminals
			</button>
			<GallMap points={points} />
    </div>
  );
}

export default MapWrapper;
